import React from "react";

interface MpstatIconProps {
  width?: string;
  height?: string;
  fillColor?: string;
  strokeColor?: string; // цвет рамки
}

export const MpstatIcon: React.FC<MpstatIconProps> = ({
  width = "20",
  height = "20",
  fillColor = "#17BF50", // основной цвет иконки
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`rounded`}
    >
      <g transform="translate(15,6) scale(1.5)">
        {" "}
        <path
          d="M15.4613 6.33667L4.5726 0.0897425C4.12999 -0.164897 3.57424 0.152576 3.57424 0.661854V13.1557C3.57424 13.665 4.12999 13.9825 4.5726 13.7278L15.4613 7.48089C15.9039 7.22625 15.9039 6.59131 15.4613 6.33667Z"
          fill={fillColor}
        />
        <path
          d="M16.6027 13.8105L12.6658 11.5518C12.4595 11.4328 12.2066 11.4328 12.0002 11.5518L2.76877 16.8496C2.32617 17.1043 1.77042 16.7868 1.77042 16.2775V6.45573C1.77042 5.9696 1.3744 5.57607 0.88521 5.57607C0.396016 5.57607 0 5.9696 0 6.45573V23.338C0 23.8473 0.552424 24.1647 0.998356 23.9101L16.606 14.9547C17.0486 14.7001 17.0486 14.0651 16.606 13.8105H16.6027Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};
